<template lang="pug">
.bannerTop(v-if="bannerDisplay && imageUrl" :style="'background-image: url(' + imageUrl +')'")
  .bannerTop-close
    i.icon-banner-close(@click="closeBanner")
</template>

<script>
import $ from 'jquery'

export default {
  data() {
    return {
      imageUrl: "",
      bannerId: null,
      bannerDisplay: true,
      storageKeys: this.$store.state.storageKeys,
      isDesktop: true,
      desktopBoundary: 1360
    }
  },
  async created() {
    if ($(window).width() < this.desktopBoundary) {
      this.isDesktop = false
    }
    $( window ).resize(() => {
      if (this.isDesktop) {
        if ($(window).width() < this.desktopBoundary) {
          this.isDesktop = false
          this.getInfo()
        }
      }
      else {
        if ($(window).width() >= this.desktopBoundary) {
          this.isDesktop = true
          this.getInfo()
        }
      }
    })
    await this.getInfo()
  },
  methods: {
    async getInfo() {
      let route = this.$store.state.URLs.api + '/' + this.$store.state.lang + this.$store.state.routes.banner
      let result = await this.$axios.get(route)
      
      if (this.isDesktop)
        this.imageUrl = result.data.desktopImageUrl
      else 
        this.imageUrl = result.data.tabletImageUrl

      this.bannerId = result.data.id
      if (localStorage.getItem(this.storageKeys.bannerId) == this.bannerId)
        this.bannerDisplay = false
    },
    closeBanner() {
      this.bannerDisplay = false
      localStorage.setItem(this.storageKeys.bannerId, this.bannerId)
    }
  }
}
</script>
